import React from 'react'
import { useContext, useState, useEffect } from 'react';
import DataContext from '../Context/DataContext';
import { useNavigate } from 'react-router-dom';
import BasicImageList from './BasicImageList';
import ProgressIndicator from '../Indicator/ProgressIndicator';

const SixMonthPregnantList = () => {
    const { isLoading,  sixMonthPregnantList, daystodelivery } = useContext(DataContext);
    const [imagelist, setImageList] = useState(sixMonthPregnantList);
    // console.log(missedAIList);

    useEffect(()=>{
        if (!isLoading){
            // console.log(sixMonthPregnantList);
            setImageList(
            imagelist.map(item =>{    
                const infolist = [
                  `Days since deworming: ${item.dayssincedeworming ===999?'NA': item.dayssincedeworming}`,
                  `Days to delivery: ${daystodelivery - item.dayssinceiv}`
                ];     
                  return (
                      [
                          item.cowid,
                          item.image1,
                          item.tag,
                          item.status,
                          item.isPregnant,
                          item.dayssincelastdelivery,
                          item.dayssinceiv,
                          infolist
                      ]
                  );        
              })
          );
        }
      },[isLoading, sixMonthPregnantList]);

  return (
    <>
     {isLoading && <ProgressIndicator /> }
    {    !isLoading && <BasicImageList title={"Six Months Pregnant"} imglist={imagelist}  />}
    </>
  )
}

export default SixMonthPregnantList